import { render, staticRenderFns } from "./ContratosAnuais.vue?vue&type=template&id=3beaf04b"
import script from "./ContratosAnuais.vue?vue&type=script&lang=js"
export * from "./ContratosAnuais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports